import React, { useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Cropper from 'react-cropper';
import { Button, Grid, Typography } from '@mui/material';
import 'cropperjs/dist/cropper.css';
import { cropLogo, toggleCropperModal } from '@/actions';
import { setUpdateLogoPending } from '@/state/actions';
import { updateLogo } from '@/modules/dataWrangler/dataWrangler';
import { resizeImage } from '@/util';
import ButtonLoading from '../ButtonLoading';
import GenericUploadModal from '../GenericUploadModal';
import useStyles from './styles';

const CropperModal = () => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const cropperRef = useRef(null);

    const logo = useSelector((state) => state.cropper?.logo) || '';

    const updateLogoPending = useSelector(
        (state) => state.user?.activeBusiness?.updateLogoPending
    );

    const handleSaveImage = async () => {
        dispatch(setUpdateLogoPending());
        const canvas = cropperRef.current.cropper.getCroppedCanvas();
        const dataURL = resizeImage(canvas).toDataURL();
        await updateLogo(dataURL);
        dispatch(toggleCropperModal(false));
        dispatch(cropLogo(''));
    };

    const setShow = (active) => dispatch(toggleCropperModal(active));
    const open = useSelector((state) => state.cropper?.open) || false;

    return (
        <GenericUploadModal
            heading="Upload Logo"
            onClose={() => setShow(false)}
            open={open}
        >
            <Grid
                container
                direction="column"
                justifyContent="space-evenly"
                alignItems="center"
            >
                <div className={classes.cropperContainer}>
                    <Grid item className={classes.cropperImage}>
                        <Cropper
                            className={classes.cropper}
                            checkOrientation={false}
                            ref={cropperRef}
                            src={logo}
                            crossOrigin="true"
                            guides={false}
                        />
                    </Grid>
                </div>

                <Grid item className={classes.textContainer}>
                    <Typography display="block" gutterBottom>
                        This logo will appear on all future invoices. This can
                        be changed in your settings.
                    </Typography>
                </Grid>
                <Grid
                    container
                    className={classes.cropperButtons}
                    direction="row"
                    justifyContent="space-around"
                    alignItems="center"
                    spacing={1}
                >
                    <Grid item xs={6}>
                        <Button
                            fullWidth
                            color="grey"
                            variant="outlined"
                            size="large"
                            onClick={() => {
                                dispatch(toggleCropperModal(false));
                            }}
                        >
                            Cancel
                        </Button>
                    </Grid>
                    <Grid item xs={6}>
                        <ButtonLoading
                            fullWidth
                            loading={updateLogoPending}
                            color="primary"
                            variant="contained"
                            size="large"
                            onClick={() => handleSaveImage()}
                            data-cy="cropper-save-logo"
                        >
                            Save
                        </ButtonLoading>
                    </Grid>
                </Grid>
            </Grid>
        </GenericUploadModal>
    );
};

export default CropperModal;
